// Powered.js
import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import update from 'react-addons-update'
import { SelectInput } from '../../partials/Inputs/Inputs'

import AppDispatcher from '../../../dispatchers/AppDispatcher'

const Powered = ({ device }) => {
  const [powered, setPowered] = useState(device.physical.powered)

  const appDispatch = useCallback(() => {
    AppDispatcher.dispatch({
      action: 'change-physical',
      setting: {
        powered,
      },
    })
  }, [powered])

  useEffect(() => {
    appDispatch()
  }, [appDispatch])

  const handleChange = useCallback((field, value, callback) => {
    let updateValue = false
    if (value === 'true' || value === true) {
      updateValue = true
    } else {
      updateValue = false
    }

    setPowered(updateValue)

    // Use setTimeout to ensure state is updated before calling appDispatch
    setTimeout(() => {
      appDispatch()
      if (callback) callback()
    }, 0)
  }, [appDispatch])

  const childChange = useCallback((event) => {
    handleChange(event.target.name, event.target.value)
  }, [handleChange])

  const unit = ''

  const select = [
    {
      value: false,
      name: 'No',
    },
    {
      value: true,
      name: 'Yes',
    },
  ]

  let currentSetting = 'No'
  if (device.physical.powered) {
    currentSetting = 'Yes'
  }

  return (
    <div>
      <section>
        <h3>
          Current Setting
        </h3>
        <ul>
          <li>
            <span>Powered Device</span>
            <span>
              {currentSetting}
              {unit}
            </span>
          </li>
        </ul>
      </section>
      <section>
        <h3>
          New Setting
        </h3>
        <ul>
          <li>
            <span>Powered Device</span>
            <span>
              <SelectInput
                value={powered}
                childChange={childChange}
                field='powered'
                options={select}
              />
              {unit}
            </span>
          </li>
        </ul>
      </section>
    </div>
  )
}

Powered.propTypes = {
  device: PropTypes.object.isRequired,
}

export default Powered
